// @flow

/**
 * @param {string} pathname - `/shelter/tag/:serialNumber`
 */
export const getTagSerialNumberFromUrlPath = (pathname: string) => pathname.split('/').pop();
